import { ApiResponse } from "../../types";
import { dashboardClient } from "../config/apiClient";
import { ProcessResult } from "../../types/output_vu";
import { ProcessResultVh } from "../../types/output_vh";

interface ListParams {
  page?: number;
  size?: number;
  status?: string[];
}

export interface ListItem {
  id: string;
  title?: string;
  createdAt: number;
  status: string;
  thumbnail?: string;
  uploadedFileName: string;
  updatedAt: number;
  projectName?: string;
  components?: string[];
  projectId?: string;
  documentId?: string;
  duration?: string;
}

interface PageInfo {
  totalPages: number;
  totalItems: number;
  size: number;
  hasNext: boolean;
  hasPrevious: boolean;
  sort?: string;
  orderBy?: string;
  status?: string[];
  isFirst?: boolean;
  isLast?: boolean;
}

interface ListResponse {
  list: ListItem[];
  count: number;
  page: PageInfo;
}

type OutputDetail = ProcessResult | ProcessResultVh;

export const getList = async (
  params: ListParams
): Promise<ApiResponse<ListResponse>> => {
  const queryParams = new URLSearchParams();

  if (params.page !== undefined)
    queryParams.append("page", params.page.toString());
  if (params.size !== undefined)
    queryParams.append("size", params.size.toString());
  if (params.status)
    params.status.forEach((status) => queryParams.append("status", status));

  const response = await dashboardClient.get<ApiResponse<ListResponse>>(
    `/output/list?${queryParams.toString()}`
  );
  return response.data;
};

export const deleteListItem = async (
  outputIds: string[]
): Promise<ApiResponse<null>> => {
  const response = await dashboardClient.delete<ApiResponse<null>>(
    `/output`,
    { data: { outputIds } }
  );
  return response.data;
};

export const getOutputDetail = async (
  outputId: string
): Promise<ApiResponse<OutputDetail>> => {
  const response = await dashboardClient.get<ApiResponse<OutputDetail>>(
    `/output/${outputId}`
  );
  return response.data;
};
